import { TIcon } from "@/app/types/types";

const OneDirectionArrow = ({ color }: TIcon) => {
    return (
        <svg className="direction-arrow" width="32" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path className="prev" d="M12.625 8.75H0.5V7.25H12.625L6.925 1.55L8 0.499999L15.5 8L8 15.5L6.925 14.45L12.625 8.75Z" fill={color} />
            <path className="next" d="M12.625 8.75H0.5V7.25H12.625L6.925 1.55L8 0.499999L15.5 8L8 15.5L6.925 14.45L12.625 8.75Z" fill={color} />
        </svg>
    );
}

export default OneDirectionArrow;